<template>
    <div class="container">
        <div class="breadcrumb">
            <a @click="$router.go(-1)">用户管理</a>
            <i>></i>
            <span>用户详情</span>
        </div>
        <div class="content">
            <div class="con_title">基础信息</div>
            <div class="details">
                <div class="detail_item">
                    <div class="detail_item_left">账 号</div>
                    <div class="detail_item_right">{{ userDetail.phoneNumber }}</div>
                </div>
                <div class="detail_item">
                    <div class="detail_item_left">注册时间</div>
                    <div class="detail_item_right">{{ formatDate(userDetail.createdAt, "y/M/d h:m") }}</div>
                </div>
            </div>
            <div class="details">
                <div class="detail_item">
                    <div class="detail_item_left">昵 称</div>
                    <div class="detail_item_right">{{ userDetail.nickname }}</div>
                </div>
                <div class="detail_item">
                    <div class="detail_item_left">活跃时间</div>
                    <div class="detail_item_right">{{ formatDate(userDetail.loginAt, "y/M/d h:m") }}</div>
                </div>
            </div>
            <div class="details">
                <div class="detail_item">
                    <div class="detail_item_left">设 备</div>
                    <div class="detail_item_right">{{ userDetail.device }}</div>
                </div>
                <!-- <div class="detail_item">
                    <div class="detail_item_left">使用次数</div>
                    <div class="detail_item_right">{{ userDetail.usedTimes }}</div>
                </div> -->
            </div>
            <div class="con_title">习惯信息</div>
            <div class="habitTitle">
                <div>名称</div>
                <div>模式</div>
                <div>力度</div>
                <div>时间</div>
                <div>温度</div>
            </div>
            <div class="habitItem" v-for="(item, index) in list" :key="index">
                <div>{{ item.name }}</div>
                <div>{{ showMode(item.mode) }}</div>
                <div>{{ item.level }}</div>
                <div>{{ showDuration(item.duration) }}</div>
                <div>{{ showTemperature(item.temperature) }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import comSelect from "../../components/comSelect";
import comPage from "../../components/comPage";
import { getHabitList } from "../../http/userPage";
export default {
    components: {
        comSelect,
        comPage,
    },
    data() {
        return {
            userDetail: {},
            list: [],
            modeList: ["循环释压", "深层舒缓", "经典刮擦", "动感按压", "活力滚转", "脉冲捶打"],
            heatList: ["关闭", "低热", "中热", "高热"],
        };
    },
    methods: {
        getList() {
            console.log(this.userDetail);
            let httpData = {
                id: this.userDetail.id,
            };
            getHabitList(httpData)
                .then((res) => {
                    // console.log(res);
                    if (res.data.errCode === 0) {
                        this.list = res.data.result;
                        // console.log(this.list);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        showMode(mode) {
            return this.modeList[mode];
        },
        showDuration(duration) {
            if (!duration) {
                return "00:00";
            }
            let min = parseInt(duration / 60);
            if (min < 10) {
                min = "0" + min;
            }
            let sec = duration % 60;
            if (sec < 10) {
                sec = "0" + sec;
            }
            return min + ":" + sec;
        },
        showTemperature(temperature) {
            return this.heatList[temperature];
        },
    },
    created() {
        let item = this.$route.query;
        this.userDetail = item;
        this.getList();
    },
};
</script>
<style lang="scss" scoped>
.content {
    width: 60%;
    margin: auto;
}
.con_title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #f7f7f7;
    font-size: 20px;
    font-weight: 550;
    padding-left: 40px;
    margin-top: 20px;
}
.details {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .detail_item {
        padding-left: 40px;
        display: flex;
        align-items: center;
        min-width: 300px;
        .detail_item_left {
            color: #787878;
            padding-right: 30px;
        }
        .detail_item_right {
            color: #333;
        }
    }
}
.habitTitle {
    margin-top: 20px;
    width: 100%;
    height: 50px;
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    display: flex;
    background: #f1efef;
    div {
        flex: 1;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 1px solid #ccc;
    }
}
.habitItem {
    width: 100%;
    height: 50px;
    border-right: 1px solid #ccc;
    display: flex;
    div {
        flex: 1;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }
}
@media only screen and (max-width: 1400px) {
    .content {
        width: 70%;
    }
}
</style>
